import { Subject } from 'rxjs';
import type { AuthStateSubset } from './AuthSlice';

export const AuthSubject = new Subject<AuthSubjectEvent>();

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type AuthSubjectEvent = { type: 'logout'; auth: AuthStateSubset };
